import React from 'react'
import { CodeLogicianLogo } from './ui/logos/logo-codelogician'
import { CodeLogicianLogoByImandra } from './ui/logos/logo-codelogician-by-imandra'
import { ImandraLogo } from './ui/logos/logo-imandra'
import { ImandraXLogo } from './ui/logos/logo-imandrax'
import { SpecLogicianLogo } from './ui/logos/logo-speclogician'
import { Join } from '../lib/utils'

export type BrandLogoVariant =
  /** Imandra wordmark — intended for imandra.dev once it migrates, and
   *  currently used by the Design Studio shell (DS lives under the Imandra
   *  umbrella). Aspect ratio is ~9.6:1 so callers typically want a smaller
   *  height (e.g. `h-6`) than the `h-8` default used by the other brands. */
  | 'imandra'
  /** @deprecated Use `'imandra'`. Kept for one cycle to avoid breaking any
   *  older consumer that pinned this string. Renders the Imandra wordmark. */
  | 'design-studio'
  /** `logo-codelogician-by-imandra` — lockup with Imandra line. */
  | 'codelogician-by-imandra'
  /** `logo-codelogician` — wordmark (mark + "CodeLogician"). */
  | 'codelogician'
  | 'speclogician'
  | 'imandrax'

export function renderBrandLogo({
  variant,
  className,
}: {
  variant: BrandLogoVariant
  className: string
}) {
  if (variant === 'codelogician') {
    return <CodeLogicianLogo className={Join('h-8 w-auto', className)} />
  }
  if (variant === 'codelogician-by-imandra') {
    return <CodeLogicianLogoByImandra className={className} />
  }
  if (variant === 'imandrax') {
    return <ImandraXLogo className={Join('w-auto', className)} />
  }
  if (variant === 'speclogician') {
    return <SpecLogicianLogo className={Join('w-auto', className)} />
  }
  if (variant === 'imandra' || variant === 'design-studio') {
    return <ImandraLogo className={Join('w-auto', className)} />
  }
  return <ImandraLogo className={Join('w-auto', className)} />
}
